{
  "slug": "free-online-iq-test-guide",
  "title": "무료 온라인 IQ 테스트: 시작 전에 알아둘 점",
  "description": "무료 온라인 IQ 테스트의 구성, 공정한 응시 방법, 결과의 의미와 전문 검사와의 차이를 설명합니다.",
  "summary": "온라인 IQ 형식 테스트는 체계적인 추론 연습과 참고용 추정치를 제공할 수 있습니다. 문항의 균형, 응시 조건, 명확한 한계를 함께 확인해야 합니다.",
  "category": "IQ 기초",
  "sections": [
    {
      "heading": "온라인 테스트가 다루는 능력",
      "paragraphs": [
        "일반적으로 패턴 인식, 수리 추론, 언어 관계, 공간 추론을 표집합니다. 한 종류의 퍼즐만 사용하는 것보다 여러 영역을 포함한 구성이 더 균형 잡힌 정보를 줍니다.",
        "브라우저 환경은 전문가가 감독하는 표준화 검사와 동일하지 않습니다. 기기, 방해, 언어, 시간, 외부 도움은 결과에 영향을 줄 수 있습니다."
      ]
    },
    {
      "heading": "공정하게 응시하는 방법",
      "paragraphs": [
        "지원되는 기기와 안정적인 연결을 사용하고 조용한 장소와 방해받지 않을 시간을 확보하세요. 지시를 따르고 허용되지 않은 검색이나 도구를 사용하지 마세요.",
        "가장 잘 이해하는 언어를 선택하세요. 장애나 접근성 요구가 형식에 영향을 준다면 적절한 조정을 제공하는 전문 평가를 고려하세요."
      ]
    },
    {
      "heading": "결과를 해석하는 방법",
      "paragraphs": [
        "결과는 해당 조건에서의 추정치이며 진단이나 영구적인 꼬리표가 아닙니다. 한 숫자보다 추정 범위, 영역별 결과, 한계를 함께 살펴보세요.",
        "교육, 임상, 채용 또는 회원 자격을 위한 결정에는 해당 목적에서 인정되는 자료가 필요합니다. Mensa International은 온라인 테스트를 입회에 사용할 수 없다고 안내합니다."
      ]
    }
  ],
  "faqs": [
    {
      "question": "무료 온라인 IQ 결과는 공식 점수인가요?",
      "answer": "아닙니다. 참고용 온라인 결과이며 감독된 전문 평가나 임상 진단이 아닙니다."
    },
    {
      "question": "같은 테스트를 반복하면 더 정확한가요?",
      "answer": "문항 형식에 익숙해지는 연습 효과가 생기므로 반드시 더 정확해지는 것은 아닙니다."
    }
  ],
  "related": ["how-can-i-find-out-my-iq", "is-an-online-iq-test-accurate", "how-is-iq-measured"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — intelligence test",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "Mensa International — getting your IQ tested",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
